/* eslint semi:0 */
/**
 * Allows adding keys/values to a single global namespace.
 * Should only be used for introspection: no code should ever
 * address the namespace.
 */
const { assign } = Object

const NAMESPACE = 'NM'
const namespace = (global[NAMESPACE] = assign(global[NAMESPACE] || Object.create(null)))

export function registerInNamespace(obj) {
  assign(namespace, obj)
  return obj
}

registerInNamespace({
  namespaceName: NAMESPACE,
})

function registerSubNamespace(subNamespace, objectToRegister) {
  namespace[subNamespace] = namespace[subNamespace] || Object.create(null)
  assign(namespace[subNamespace], objectToRegister)
  return objectToRegister
}

export const registerUtils = registerSubNamespace.part('utils')
export const registerProvider = registerSubNamespace.part('providers')

export { NAMESPACE }
export default namespace



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/nm.js